__turbopack_context__.v({
  "wrapper": "Content-module-scss-module__aIz6HW__wrapper",
});
